module.exports = __webpack_public_path__ + "media/images/logo/Logo copia grande-db2de5d3a6b07c78128da0ebc2467b3e.png";